import React, { useEffect, useState } from "react";
import { authFetch } from "../../api";

const inputClass = "w-full px-4 py-2 rounded-lg bg-white/5 border border-navy-border text-white focus:outline-none focus:border-accent-light";

const fields = [
  { key: "company_name", label: "Company Name" },
  { key: "about_text", label: "About Text" },
  { key: "email", label: "Email" },
  { key: "pakistan_phone_1", label: "Pakistan Phone 1" },
  { key: "pakistan_phone_2", label: "Pakistan Phone 2" },
  { key: "uae_mobile", label: "UAE Mobile" },
  { key: "qatar_mobile", label: "Qatar Mobile" },
  { key: "facebook_url", label: "Facebook URL" },
  { key: "twitter_url", label: "Twitter URL" },
  { key: "instagram_url", label: "Instagram URL" },
  { key: "youtube_url", label: "YouTube URL" },
];

export default function FooterSettings() {
  const [data, setData] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    authFetch("/core/footer/")
      .then((res) => res.json())
      .then(setData)
      .catch(() => setError("Failed to load footer content."));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    try {
      const res = await authFetch("/core/footer/", { method: "PATCH", body: JSON.stringify(data) });
      if (!res.ok) throw new Error();
      setMessage("Footer content updated.");
    } catch {
      setError("Failed to save.");
    }
  };

  if (!data) return <p className="text-gray-400">Loading...</p>;

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold mb-6">Footer</h1>
      <form onSubmit={handleSave} className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          {fields.map((f) => (
            <div key={f.key} className={f.key === "about_text" ? "col-span-2" : ""}>
              <label className="block text-sm text-gray-300 mb-1">{f.label}</label>
              <input
                className={inputClass}
                value={data[f.key]}
                onChange={(e) => setData({ ...data, [f.key]: e.target.value })}
              />
            </div>
          ))}
        </div>
        {message && <p className="text-sm text-green-400">{message}</p>}
        {error && <p className="text-sm text-red-400">{error}</p>}
        <button className="px-6 py-2 rounded-lg bg-brand-gradient text-white font-semibold">
          Save Changes
        </button>
      </form>
    </div>
  );
}
